import { useEffect, useState } from 'react';
import { fieldHour, skyMood, type SkyInputs, type SkyMood } from '../../../domain/SkyMood';

// Para ver cada efecto sin esperar al clima: /app/dashboard?cielo=lluvia
const PREVIEW: Record<string, Partial<SkyInputs>> = {
  lluvia: { rainLastHour: 1, weatherCode: 61 },
  tormenta: { rainLastHour: 8, weatherCode: 95, windKmh: 35 },
  viento: { windKmh: 24, rainLastHour: 0, weatherCode: 1 },
  ventarron: { windKmh: 40, rainLastHour: 0, weatherCode: 2 },
  calor: {
    hour: 14,
    temperature: 33,
    rainLastHour: 0,
    weatherCode: 0,
    windKmh: 5,
  },
  nublado: { weatherCode: 3, rainLastHour: 0 },
  amanecer: { hour: 7, weatherCode: 0, rainLastHour: 0 },
  atardecer: { hour: 19.5, weatherCode: 0, rainLastHour: 0 },
  noche: { hour: 23, weatherCode: 0, rainLastHour: 0 },
};

export function useSkyMood(inputs: Omit<SkyInputs, 'hour'>): SkyMood {
  // La hora avanza sola: el cielo cambia aunque la pantalla quede abierta.
  const [hour, setHour] = useState(() => fieldHour());
  useEffect(() => {
    const id = setInterval(() => setHour(fieldHour()), 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);
  const preview = PREVIEW[new URLSearchParams(window.location.search).get('cielo') ?? ''];
  return skyMood({ hour, ...inputs, ...preview });
}
